import { DialogOrDrawer } from '@ui/components/DialogOrDrawer';

import { TokenList } from './TokenList';

export const DefaultContent = () => {
  return (
    <>
      <DialogOrDrawer.Header flexDirection="column">
        <DialogOrDrawer.Title>select token</DialogOrDrawer.Title>
      </DialogOrDrawer.Header>
      <DialogOrDrawer.Body className="no-scrollbar" pt="0px">
        <TokenList />
      </DialogOrDrawer.Body>
    </>
  );
};
